import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { StatusCardService } from './status-card.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-status-card',
  styleUrls: ['./status-card.component.scss'],
  template: `
    <nb-card (click)="calFlunctionClick()" [ngClass]="{'escolherProduto': !values.produtoEscolhido}">
      <div class="icon-container">
        <div class="icon status-{{ values.type }}">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="form-row align-items-center">
        <div class="details">
          <div class="title h6">{{ values.title }}</div>
          <div class="status paragraph-2">{{ values.produtoEscolhido ? 'produto Escolhido' : 'Escolher Produto' }}</div>
        </div>
    <!--    <div class="details">
          <div class="status paragraph-2" *ngIf="isLimiteAdianta">Limite Global: {{ limiteAdianta | currency:'BRL':'symbol':'0.2-2':'pt' }}</div>
          <div class="status paragraph-2" *ngIf="isLimiteSalario">Saldo: {{ limiteSalario | currency:'BRL':'symbol':'0.2-2':'pt' }}</div>
          <div class="status paragraph-2" *ngIf="isRecebiveis">Recebíveis: {{ totalAmount | currency:'BRL':'symbol':'0.2-2':'pt' }}</div>
        </div> -->
      </div>
    </nb-card>
  `,
})
export class StatusCardComponent {

  @Input() values: any;
  public limiteAdianta = null;
  public limiteSalario = null;
  public totalAmount = null;
  public isLimiteAdianta = false;
  public isLimiteSalario = false;
  public isRecebiveis = false;

  @Output('clickEvent') clickEvent = new EventEmitter();

  constructor(

    private service: StatusCardService,
    private encriptyService: EncriptyUtilService,

  ) {


  }

  calFlunctionClick() {

    this.values.produtoEscolhido = !this.values.produtoEscolhido;
    this.clickEvent.emit({ id: this.values.id, title: this.values.title });

    //let produtoId = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));


    this.limiteSalario = null;
    this.totalAmount = null;
    this.limiteAdianta = null;

    //this.infoCards(this.values.title);
  }

  infoCards(title: string) {
    if(title=== 'ADIANTA'){

      this.isLimiteAdianta = true;
      this.isRecebiveis = false;
      this.isLimiteSalario = false;
      this.service.buscaLimiteGlobal(null, (response) => {
        this.limiteAdianta =  response.limiteAtual
      }, null)

    }
    if(title === 'SALARIO'){

      this.isLimiteSalario = true;
      this.isLimiteAdianta = false;
      this.isRecebiveis = false;
      this.service.buscaLimiteGlobal(null, (response) => {
        this.limiteSalario =  response.saldoAtual
      }, null)

    }
    if(title === 'VAREJO'){

      this.isRecebiveis = true;
      this.isLimiteSalario = false;
      this.isLimiteAdianta = false;
      this.service.balanceDetailViewList(null, (response) => {
        this.totalAmount =  response.totalAmount
      }, null)

    }

  }
}
